import React from "react";

// region Libraries
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
// endregion Libraries
// region Languages
import useTranslation from "src/translations/useTranslation";
import { GlobalMessages, LoginMessages } from "@shared/languages/interfaces";
// endregion Languages
// region Constants
import { IDENTITY_MIGRATION } from "@shared/constants/identity-migration.constants";
// endregion Constants

/**
 * Whether a backend answer (the body of a response or of an error response) is the refusal for
 * a user migrated to Topcon Identity.
 * @param payload Response body
 */
export const isIdentityMigrated = (payload: { errorCode?: string } | undefined | null): boolean => (
  payload?.errorCode === IDENTITY_MIGRATION.ERROR_CODE
);

interface DialogIdentityMigratedProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Shown when a user migrated to Topcon Identity tries the FLEET password: explains that the
 * access is now through Topcon Suite, links to it and tells how to set the password there.
 */
const DialogIdentityMigrated: React.FC<DialogIdentityMigratedProps> = ({ open, onClose }) => {

  const { t } = useTranslation();

  return (
    <Dialog
      style={{ zIndex: 2000 }}
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="identity-migrated-title"
      aria-describedby="identity-migrated-description"
    >
      <DialogTitle id="identity-migrated-title">{t(LoginMessages.identityMigratedTitle)}</DialogTitle>
      <DialogContent>
        <DialogContentText id="identity-migrated-description">
          {t(LoginMessages.identityMigratedInstructions)}
        </DialogContentText>
        <DialogContentText>
          {t(LoginMessages.identityMigratedFirstAccess)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disableRipple onClick={onClose} color="primary">
          {t(GlobalMessages.close)}
        </Button>
        <Button disableRipple variant="contained" color="primary" href={IDENTITY_MIGRATION.PORTAL_URL}>
          {t(LoginMessages.goToTopconSuite)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogIdentityMigrated;
